import Vue from 'vue';
const initialFilter = {
  PhoneId: null,
  fromDate: null,
  toDate: null,
};
export default {
  data() {
    return {
      searchTitle: '',
      tableHeaders: [
        {
          text: 'ردیف',
          value: 'rowNumber',
        },
        {
          text: 'تاریخ شروع',
          value: 'startDate',
        },
        {
          text: 'کد گوشی',
          value: 'phoneCode',
        },
        {
          text: 'عملیات',
          value: 'action',
        },
      ],
      hasSearch: false,
      filterData: initialFilter,
      isFilterModalOpen: false,
      isDetailModalOpen: false,
      detailId: null,
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalItems: 0,
      },
    };
  },
  computed: {
    hasSearch: function () {
      return Object.values(this.filterData)?.some((value) => !!value);
    },
    detailData: function () {
      if (!this.detailId) return {};
      else {
        const data = [...this.takeoffLandingList]?.find(({ id }) => id === this.detailId);
        return {
          phoneCode: data?.phoneCode,
          startDate: data?.startDate,
          typeOfAirStation: data?.typeOfAirStation,
          exitReason: data?.exitReason,
          sourceCity: data?.sourceCity,
          items: [...data?.airAmbulanceLandingTakeOffDetails]?.map((item) => ({
            ...item,
            departureDate: item?.departureDate
              ? Vue.moment(item.departureDate).format('HH:mm:ss jYYYY/jMM/jDD')
              : '-',
            arrivalDate: item?.arrivalDate
              ? Vue.moment(item.arrivalDate).format('HH:mm:ss jYYYY/jMM/jDD')
              : '-',
          })),
        };
      }
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getTakeoffAndLandingList();
      this.getAllPhones();
    },
    transformTakeoffAndLandingList: function (takeoffAndLandingList) {
      return [...takeoffAndLandingList]?.map((item, index) => ({
        id: item?.id,
        rowNumber: index + 1,
        startDate: item?.phoneActivity?.startDate
          ? Vue.moment(item?.phoneActivity?.startDate).format(' HH:mm:ss jYYYY/jMM/jDD')
          : '-',
        phoneCode: item?.phoneActivity?.phone?.code,
        ...item,
      }));
    },
    openFilterModal: function () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal: function () {
      this.isFilterModalOpen = false;
    },
    openDetailModal: function (id) {
      this.detailId = id;
      this.isDetailModalOpen = true;
    },
    closeDetailModal: function () {
      this.isDetailModalOpen = false;
      this.detailId = null;
    },
    setPagination: function (data) {
      this.pagination.totalItems = data?.totalItems;
    },
    resetPageNumber: function () {
      this.pagination.pageNumber = 1;
    },
    onGettingList: function () {
      const params = {
        ...this.filterData,
        ...this.pagination,
      };
      this.getTakeoffAndLandingList(params);
    },
    setFilter: function (filterData) {
      this.resetPageNumber();
      this.filterData = filterData;
      this.onGettingList();
      this.closeFilterModal();
    },
    clearFilter: function () {
      this.filterData = initialFilter;
    },
  },
};
